<template>
  <div
    :class="[
      'CustomiserButtonB',
      {
        'CustomiserButtonB--enabled': enabled,
        'CustomiserButtonB--border': border,
      },
    ]"
  >
    <div
      :class="$b('inner')"
      @click="$emit('click')"
    >
      <VisionButton
        class="CustomiserButtonB__button"
        background-colour="white"
        :square="true"
        size="small"
      >
        <template #content>
          <slot />
        </template>
      </VisionButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomiserButtonB',
  props: {
    enabled: { type: Boolean, required: true },
    border: { type: Boolean, default: false },
  },
  emits: ['click']
}
</script>

<style lang="postcss" scoped>
.CustomiserButtonB {
  @apply p-0 w-full;
}

.CustomiserButtonB__inner {
  @apply flex items-center justify-center
    normal-case
    w-full;
}

.CustomiserButtonB__button {
  @apply flex items-center justify-center
    w-full relative cursor-pointer text-center;
}
</style>
